import { X } from 'lucide-react';

function DataPrivacyModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-dark-slate border-2 border-gold/30 rounded-2xl max-w-2xl w-full max-h-[80vh] flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10 flex-shrink-0">
          <h2 className="text-2xl font-bold text-white">Data Privacy Policy</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
            aria-label="Close"
          >
            <X className="w-6 h-6 text-neutral-grey-300" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto flex-1 p-6 space-y-6">
          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">Information We Collect</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              When you record a video message using MomentBox, we collect:
            </p>
            <ul className="list-disc list-inside text-neutral-grey-300 mt-2 space-y-2 ml-4">
              <li>Your video recording</li>
              <li>Your name (if provided)</li>
              <li>Your email address (optional)</li>
              <li>Recording timestamp and metadata</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">How We Use Your Information</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              Your information is used solely to:
            </p>
            <ul className="list-disc list-inside text-neutral-grey-300 mt-2 space-y-2 ml-4">
              <li>Deliver your video message to the event host</li>
              <li>Allow the host to identify who sent the message</li>
              <li>Contact you if you provided an email (optional)</li>
              <li>Create a memorable collection of messages for the event</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">Data Storage and Security</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              Your video and information are securely stored using industry-standard encryption.
              Only the event host has access to view your video message. We do not share, sell,
              or distribute your personal information to third parties.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">Your Rights</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              You have the right to:
            </p>
            <ul className="list-disc list-inside text-neutral-grey-300 mt-2 space-y-2 ml-4">
              <li>Request deletion of your video message</li>
              <li>Access the information we have about you</li>
              <li>Update or correct your information</li>
              <li>Opt out of email communications</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">Consent</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              By recording a video message, you consent to the collection, storage, and use of
              your information as described in this privacy policy. You also grant the event host
              permission to view and save your video message.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold text-gold mb-3">Contact</h3>
            <p className="text-neutral-grey-300 leading-relaxed">
              If you have questions about your privacy or wish to exercise your rights, please
              contact the event host directly or reach out to us at{' '}
              <a href="mailto:privacy@momentbox.com" className="text-gold hover:text-gold-light underline">
                privacy@momentbox.com
              </a>
            </p>
          </section>

          <section className="pt-4 border-t border-white/10">
            <p className="text-neutral-grey-400 text-sm italic">
              Last updated: February 2026
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-white/10 flex-shrink-0 bg-dark-slate rounded-b-2xl">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-gold hover:bg-gold-light text-dark-slate font-bold rounded-xl transition-all"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}

export default DataPrivacyModal;
